export const LOG_CATEGORIES = {
  WS: `[WS]`,
  WIDGET: `[WIDGET]`,
  MAXED_DAILER: `[MAXED_DIALER]`,
  DIALER_LIST: `[DIALER LIST]`,
  NOTIFICATIONS: `[NOTIFICATIONS]`,
  TWILIO: `[TWILIO_CUSTOM]`,
  FOLLOW_UP_EMAIL: `[FOLLOW_UP_EMAIL]`,
  DISPOSITION: `[DISPOSITION]`,
  VERSION: `[VERSION]`,
} as const;
